module.exports = __webpack_public_path__ + "static/media/riverfront-north-partnership.f967a374.md";